


























import Vue from "vue";
import Tabs from "@/components/Tabs.vue";
import MoneyDisplay from "@/components/MoneyDisplay.vue";
import { PreAccItem, PreAccItemDim } from "../models/PreAccounting";
import { t } from "@/plugins/i18n";

const ROMAN = ["IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"];

interface Methods {
  dimsByType(type: number): PreAccItemDim[];
  dimColumnsFor(type: number): any[];
}

interface Computed {
  dimTypes: { type: number; label: string }[];
  defaultTabIndex: number;
}

export default Vue.extend<{}, Methods, Computed, {}>({
  props: {
    preAccItem: { type: Object as () => PreAccItem },
  },

  components: {
    Tabs,
    MoneyDisplay,
  },

  methods: {
    dimsByType(type: number): PreAccItemDim[] {
      return ((this.$props.preAccItem.dims ?? []) as PreAccItemDim[]).filter(
        (x) => x.dimCodeType === type
      );
    },

    // Dimenziónként eltérő kísérő oszlopok — a K2D d_g_accitem_d_new
    // láthatóság-térképe szerint (V/VI/VII/VIII/IX/X fül; a IV, XI, XII csak
    // az alap). A kulcs a dimcodetype: 6=V. fül ... 11=X. fül (ld. dimTypes).
    dimColumnsFor(type: number): any[] {
      const base: any[] = [
        { field: "dimCodeTypeName", title: t("PreAccounting_DimenzioTipus"), width: "180px" },
        { field: "dimCode", title: t("DimenzioKod") },
      ];

      const extras: Record<number, any[]> = {
        6: [
          { field: "extProdParts", title: t("SelejtCikk") },
          { field: "extProdPartsCode", title: t("Cikkszam") },
          { field: "extProdPartsName", title: t("Megnevezes") },
        ],
        7: [
          { field: "productParts", title: t("GyartottTermek") },
          { field: "productPartsCode", title: t("Cikkszam") },
          { field: "productPartsName", title: t("Megnevezes") },
          { field: "production", title: t("GyartasInformacio") },
          { field: "stock", title: t("Keszlet") },
        ],
        8: [
          { field: "carId", title: t("Gepjarmu") },
          { field: "regNum", title: t("Rendszam") },
        ],
        9: [
          { field: "userName", title: t("Munkatars") },
          { field: "stationName", title: t("Munkaallomas") },
          { field: "toolName", title: t("Szerszam") },
        ],
        10: [
          { field: "project", title: t("Projekt") },
          { field: "projectName", title: t("ProjektNeve") },
          { field: "poId", title: t("Megrendeles") },
          { field: "poNumber", title: t("MegrendelesSzam") },
          { field: "workNumber", title: t("Munkaszam") },
        ],
        11: [
          { field: "extProdPartner", title: t("KiegeszitoPartner") },
          { field: "extProdPartnerName", title: t("PartnerNeve") },
        ],
      };

      return [
        ...base,
        ...(extras[type] ?? []),
        { field: "total", title: t("Osszeg"), cell: "dimTotalTemplate", width: "160px" },
        { width: 0 },
      ];
    },
  },

  computed: {
    dimTypes() {
      // K2D-paritás: a csaccdimcodetype-ban az 5 = IV.dim ... 13 = XII.dim
      // (a K2D a fület selectedtab + 4-gyel kérdezi le), ezért a fül
      // dimcodetype-ja a fül-index + 5.
      return ROMAN.map((label, i) => ({ type: i + 5, label: t("GeneralLedger_Dimenzio", [label]) }));
    },

    // K2D retrieveend-minta (mint a kontír dim-szerkesztőben): a legkisebb
    // LÉTEZŐ dimcodetype füle nyílik meg; bontás nélkül az első (IV.) fül.
    defaultTabIndex() {
      const existing = ((this.$props.preAccItem.dims ?? []) as PreAccItemDim[])
        .map((x) => x.dimCodeType)
        .filter((t) => t >= 5 && t <= 13)
        .sort((a, b) => a - b);
      return existing.length > 0 ? existing[0] - 5 : 0;
    },
  },
});
